import validate from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication_45global from "/usr/src/app/middleware/authentication.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authentication_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}